<section>
    <div class="container">
        <div class="row">
            <form [formGroup]="form">
                <div class="col-md-12">
                    <div class="user-dashboard-info-box">
                        <div class="section-title-02 mb-2">
                            <h4>Basic Information</h4>
                        </div>
                        <div class="cover-photo-contact">
                            <div class="upload-file">
                                <div class="custom-file">
                                    <app-upload [title]="'Upload CV'" [acceptedFiles]="'.doc,.docx,.pdf'" (onUploadFinished)="uploadFinished($event)"></app-upload>
                                </div>
                                {{fileName}}
                                {{uploadStatus}}
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label>Your Name *</label>
                                <input type="text" class="form-control" formControlName="name"
                                    [class.is-invalid]="form.controls['name'].touched && form.controls['name']?.errors">
                            </div>
                            <div class="form-group col-md-6">
                                <label>Email *</label>
                                <input type="email" class="form-control" formControlName="email"
                                    [class.is-invalid]="form.controls['email'].touched && form.controls['email']?.errors">
                            </div>
                            <div class="form-group col-md-6">
                                <label>Phone</label>
                                <input type="text" class="form-control" formControlName="phone"
                                    [class.is-invalid]="form.controls['phone'].touched && form.controls['phone']?.errors">
                            </div>
                            <div class="form-group col-md-6">
                                <label>Current / Recent Job Title</label>
                                <input type="text" class="form-control" formControlName="title">
                            </div>
                            <div class="form-group col-md-6">
                                <label>Current / Recent Salary</label>
                                <input type="text" class="form-control" formControlName="salary"
                                    [class.is-invalid]="form.controls['salary'].touched && form.controls['salary']?.errors">
                            </div>
                            <div class="form-group mb-0 col-md-12">
                                <label>Cover letter</label>
                                <textarea class="form-control" rows="15" formControlName="coverLetter"
                                    placeholder="Please give a brief description of your skills and experiences."></textarea>
                            </div>
                        </div>
                    </div>
                    <a class="btn btn-md btn-primary" [routerLink]="" (click)="apply()">Apply</a>
                </div>
            </form>
        </div>
    </div>
</section>